
// Core imports
import classNames from 'classnames';
import PropTypes from 'prop-types';

// Component imports
import { Divider, Typography } from 'antd';
import { ArrowDownIcon } from '../Icons/ArrowDownIcon';

/**
 * Renders a section header for forms. Basically a divider with a title and an icon.
 * Can be used within a Collapse.Panel, so that when clicked, the form section is collapsed.
 *
 * @component
 * @param {object} props Component props
 * @param {string} props.title The title of the section.
 * @param {boolean} [props.uppercase=true] Whether the title should be uppercase or not.
 * @param {boolean} [props.collapsible=true] Whether the section should be collapsible or not.
 * @returns {JSX.Element} The rendered section header.
 */
const FormSectionHeader = ({
  title,
  uppercase = true,
  collapsible = true
}) => {

  const renderTitle = () => {
    if (typeof title === 'string') {
      return uppercase ? title?.toLocaleUpperCase?.() : title;
    }

    if(typeof title === 'object' && !!title) {
      return title;
    }

    return null;
  };

  return (
    <Divider
      className={classNames('fs-base', {
        'ant-divider-primary': collapsible
      })}
      orientation="left"
    >
      <Typography.Text strong>
        <span className="title">
          {renderTitle()}
        </span>

        {
          collapsible ? (
            <span className="ml-3 icon">
              <ArrowDownIcon className="fs-base"/>
            </span>
          ) : null
        }
      </Typography.Text>
    </Divider>
  );
};

FormSectionHeader.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]).isRequired,
  uppercase: PropTypes.bool,
  collapsible: PropTypes.bool
};

export default FormSectionHeader;
